import {Injectable} from '@angular/core';
import {Observable, of, take} from 'rxjs';
import {environment} from '@environments/environment';
import {HttpClient, HttpParams} from '@angular/common/http';
import {AutoCompleteResult, PaginatedResult, PaginatedSearch} from '@core/api/common';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  private static QUERY_PARAM_PAGE = 'page';
  private static QUERY_PARAM_TERM = 'term';

  constructor(
    protected readonly http: HttpClient
  ) { }

  public getOne<EntityResponseT>(url: string): Observable<EntityResponseT | null> {
    return this.http.get<EntityResponseT>(url).pipe(
      take(1)
    );
  }

  public paginateGet<EntityResponseT>(
    url: string,
    options: PaginatedSearch = {}
  ): Observable<PaginatedResult<EntityResponseT>> {
    const params: {[param: string]: string;} = {};
    if (options.page) {
      params[ApiService.QUERY_PARAM_PAGE] = options.page.toString();
    }
    return this.http.get<PaginatedResult<EntityResponseT>>(
      url,
      {
        params: new HttpParams({fromObject: params})
      }
    ).pipe(
      take(1)
    );
  }

  public autocomplete<PreviewT>(apiPrefix: string, term?: string): Observable<AutoCompleteResult<PreviewT>> {
    const trimmed = term?.trim();
    if (!trimmed || trimmed.length === 0) {
      return of({
        search: '',
        items: []
      });
    }
    return this.http.get<AutoCompleteResult<PreviewT>>(
      `${environment.apiUrl}/${apiPrefix}/autocomplete`,
      {
        params: new HttpParams({
          fromObject: {
            [ApiService.QUERY_PARAM_TERM]:trimmed
          }
        })
      }
    ).pipe(
      take(1)
    );
  }

}
